<div class="h-full w-full" style="">
  <div  *ngIf="isLoading"  class="map-container">
    <style>
      .no_opacity{
        opacity: 0;
      }
    </style>
    <div class="border-round border-1 surface-border p-4 surface-card">
      <div class="flex justify-content-between mt-3">
        <p-skeleton shape="circle" size="2rem" styleClass="mr-2"></p-skeleton>
        <p-skeleton shape="circle" size="2rem" styleClass="mr-2"></p-skeleton>
      </div>
      <div class="flex mb-3">
      </div>
      <div class="flex mb-3">
        <p-skeleton shape="circle" size="2rem" styleClass="mr-2"></p-skeleton>
      </div>
      <div class="flex mb-3">
        <p-skeleton shape="circle" size="2rem" styleClass="mr-2"></p-skeleton>
      </div>
      <div class="flex mb-3">
        <p-skeleton shape="circle" size="2rem" styleClass="mr-2"></p-skeleton>
      </div>
      <div class="flex mb-3">
        <p-skeleton shape="circle" size="2rem" styleClass="mr-2"></p-skeleton>
      </div>

      <p-skeleton width="100%" height="255px" class="no_opacity"></p-skeleton>
      <div class="flex justify-content-between mt-3">
        
        <p-skeleton width="4rem" height="2rem" class="no_opacity"></p-skeleton>
        <p-skeleton width="25rem" height="2.5rem"></p-skeleton>
      </div>
    </div>
  </div>
  <div  *ngIf="!isLoading" class="row h-full w-full" >
    <div class="map-container" [class.extended-height]="selectedEntityTypes.length > 6 || (!selectedEntityTypes.length && entities.length > 0)" style="direction: ltr; width: 100%; ">
      <app-arcgis-map [RightClick]="handleRightClick()" [shapes]="shapes" [mapControls]="mapControls" [extentAll]="!selectedEntityId" [popupEnabled]="true" [lang]="currentLanguage" [selectedEntityId]="selectedEntityId" [autoExpandSearch]="autoExpandSearch" (updateSelectedEntitiesFromMap)="handleSelectedEntitiesFromMap($event)" (viewReady)="handleMapViewReady($event)"></app-arcgis-map>
    </div>
  </div>
</div>
